import { CompanyInterface } from "../../models/GeneralModule/Company";
import client from "../client";

class CompanyService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/Companies/Get`;
      let form: { page: number; pageSize: number } = {
        page,
        pageSize,
      };
      const { data } = await client.post<CompanyInterface[]>(url, form);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/Companies/GetById/${id}`;

      const { data } = await client.get<CompanyInterface>(url);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Save(category: CompanyInterface) {
    try {
      let url = `/api/Companies/Add`;

      const { data } = await client.post<CompanyInterface>(url, category);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, category: CompanyInterface) {
    try {
      let url = `/api/Companies/Update/${id}`;

      const { data } = await client.post<CompanyInterface>(url, category);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `/api/Companies/Remove/${id}`;
      await client.post<CompanyInterface>(url, { url: "" });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default new CompanyService();
